module.exports = __webpack_public_path__ + "ef8f352105307da5f835cf1b1fc8e2ac.png";


//////////////////
// WEBPACK FOOTER
// ./components/home/landing/tr/reports-background.png
// module id = 621
// module chunks = 0